import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ScreenshotApp from './ScreenshotApp'

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  const pathname = window.location.pathname
  const RootComponent = pathname === '/screenshot' ? ScreenshotApp : App
  root.render(
    <StrictMode>
      <RootComponent />
    </StrictMode>,
  )
}